export const DEFAULT_PAGE = 0;
export const ROWS_PER_PAGE = 5;
export const SUCCESS_MESSAGE_DURATION = 4000;
export const TABLE_HEAD_CELLS = [
  {
    label: 'Pattern',
    width: '65%',
  },
  {
    label: 'Size',
    width: '10%',
  },
  {
    label: 'Count',
    width: '10%',
  },
  {
    label: 'Action',
    width: '15%',
  },
];
